import { render, staticRenderFns } from "./attachment-v2.vue?vue&type=template&id=867b27ba&scoped=true&"
import script from "./attachment-v2.vue?vue&type=script&lang=js&"
export * from "./attachment-v2.vue?vue&type=script&lang=js&"
import style0 from "./attachment-v2.vue?vue&type=style&index=0&id=867b27ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867b27ba",
  null
  
)

export default component.exports